export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (!location.hash) {
    window.requestAnimationFrame(() => window.scrollTo(0, 0))
  }
  return false
}
